/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillPreCheckRespVo
 */
export interface BillPreCheckRespVo {
    /**
     * 是否可创建账单
     * @type {boolean}
     * @memberof BillPreCheckRespVo
     */
    canCreate?: boolean;
    /**
     * 不可创建原因码：ORDER_STATUS_CHANGED / ORDER_DATA_CHANGED / UNPAID_BILL_EXISTS / BILL_ORDER_OUTBOUND_CANCELLED / BILL_EXISTS_ACTIVE
     * @type {string}
     * @memberof BillPreCheckRespVo
     */
    reasonCode?: string;
    /**
     * 不可创建原因描述
     * @type {string}
     * @memberof BillPreCheckRespVo
     */
    reasonMsg?: string;
    /**
     * 当前订单状态（前端记录，保存时回传）
     * @type {number}
     * @memberof BillPreCheckRespVo
     */
    orderStatus?: number;
    /**
     * 当前订单修改时间（前端记录，保存时回传，用于乐观锁校验）
     * @type {string}
     * @memberof BillPreCheckRespVo
     */
    orderUpdateTime?: string;
    /**
     * 当前订单类型
     * @type {number}
     * @memberof BillPreCheckRespVo
     */
    orderType?: number;
    /**
     * 当前订单下未删除的商品数量（前端记录，保存时回传用于一致性校验）
     * @type {number}
     * @memberof BillPreCheckRespVo
     */
    goodsCount?: number;
    /**
     * 代买取消订单及商品数据快照标识，保存时原样回传，用于识别同秒内的数量或状态变更
     * @type {string}
     * @memberof BillPreCheckRespVo
     */
    orderDataToken?: string;
}

/**
 * Check if a given object implements the BillPreCheckRespVo interface.
 */
export function instanceOfBillPreCheckRespVo(value: object): value is BillPreCheckRespVo {
    return true;
}

export function BillPreCheckRespVoFromJSON(json: any): BillPreCheckRespVo {
    return BillPreCheckRespVoFromJSONTyped(json, false);
}

export function BillPreCheckRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillPreCheckRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'canCreate': json['canCreate'] == null ? undefined : json['canCreate'],
        'reasonCode': json['reasonCode'] == null ? undefined : json['reasonCode'],
        'reasonMsg': json['reasonMsg'] == null ? undefined : json['reasonMsg'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'orderUpdateTime': json['orderUpdateTime'] == null ? undefined : json['orderUpdateTime'],
        'orderType': json['orderType'] == null ? undefined : json['orderType'],
        'goodsCount': json['goodsCount'] == null ? undefined : json['goodsCount'],
        'orderDataToken': json['orderDataToken'] == null ? undefined : json['orderDataToken'],
    };
}

export function BillPreCheckRespVoToJSON(json: any): BillPreCheckRespVo {
    return BillPreCheckRespVoToJSONTyped(json, false);
}

export function BillPreCheckRespVoToJSONTyped(value?: BillPreCheckRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'canCreate': value['canCreate'],
        'reasonCode': value['reasonCode'],
        'reasonMsg': value['reasonMsg'],
        'orderStatus': value['orderStatus'],
        'orderUpdateTime': value['orderUpdateTime'],
        'orderType': value['orderType'],
        'goodsCount': value['goodsCount'],
        'orderDataToken': value['orderDataToken'],
    };
}

